import { PartnerType } from '../../../types/external'
import type { AppDispatch } from '../../../store/types'
import { FlyoutOnboardingSectionName, type Sections } from '../types'
import { updateAccount } from './updateAccount'

export const processPartnerDetailsData = async (
  partnerId: string,
  onboardingData: Sections,
  dispatch: AppDispatch
) => {
  const sectionDetails =
    onboardingData[FlyoutOnboardingSectionName.LABRA_PARTNER_DETAILS]
  const payload: Record<string, unknown> = {
    companyName: sectionDetails.companyName,
    companyIndustry: sectionDetails.industry,
    companyWebsite: sectionDetails.companyWebsite,
  }
  await dispatch(updateAccount(partnerId || '', PartnerType.User, payload, {}))
}
